<div class="pdf-content">
  <section class='pdf' id="pdfTable" #pdfTable>
    <div class='header'>
      <svg width="936" height="72" viewBox="0 0 936 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="936" height="72" fill="#00AB57" />
        <g clip-path="url(#clip0)">
          <path
            d="M418.346 48.7028C418.326 48.7016 418.305 48.6954 418.288 48.6849C418.27 48.6744 418.255 48.6597 418.244 48.6421C418.235 48.6271 418.229 48.6105 418.227 48.5932C418.225 48.5759 418.227 48.5583 418.232 48.5418L412 59.8009C413.464 60.6125 414.633 58.8018 415.668 56.9327L420.606 48.2832C419.87 48.4865 419.119 48.6267 418.36 48.7023L418.346 48.7028Z"
            fill="white" />
          <path opacity="0.8" d="M426.765 32.7092L423.857 30.0039L426.301 33.5696L426.765 32.7092Z" fill="white" />
          <path
            d="M425.519 27.1123L418.595 17.0938C417.243 18.0271 417.115 20.1821 418.306 21.9086L423.857 30.006L426.301 33.5717L426.765 32.7113L427.387 31.5587L425.519 27.1123Z"
            fill="white" />
          <path opacity="0.8" d="M425.775 34.5449L422.356 32.7109L425.285 35.4546L425.775 34.5449Z" fill="white" />
          <path
            d="M423.857 30.0039L416.02 22.7148C414.901 23.919 415.238 26.0499 416.774 27.4786L422.357 32.7097L425.285 35.4533L425.776 34.5437L426.301 33.5696L423.857 30.0039Z"
            fill="white" />
          <path opacity="0.8" d="M427.915 30.5785L425.519 27.1113L427.387 31.5564L427.915 30.5785Z" fill="white" />
          <path
            d="M422.38 12C420.868 12.6431 420.306 14.7271 421.126 16.6581L425.519 27.1118L427.388 31.5569L427.915 30.579L428.966 28.6318L429.256 28.1886L422.38 12Z"
            fill="white" />
          <path
            d="M421.262 35.5237L414.159 33.8242C413.777 35.4219 415.119 37.112 417.159 37.6016L423.315 39.0994L424.343 37.1929L421.262 35.5237Z"
            fill="white" />
          <path opacity="0.8" d="M424.791 36.3682L421.262 35.5234L424.346 37.1926L424.791 36.3682Z" fill="white" />
          <path
            d="M422.357 32.7104L414.117 28.2891C413.34 29.7362 414.207 31.7127 416.056 32.7052L421.265 35.5242L424.349 37.1933L424.793 36.3689L425.287 35.4541L422.357 32.7104Z"
            fill="white" />
          <path
            d="M450.531 23.9478L440.033 23.8952C435.446 21.3576 434.43 21.4291 431.696 24.4549L429.255 28.1878L428.966 28.631L427.915 30.5782L427.387 31.556L426.765 32.7086L426.301 33.569L425.775 34.543L425.285 35.4527L424.791 36.3676L424.346 37.192L423.318 39.0984L418.239 48.5108C418.235 48.5204 418.233 48.5304 418.232 48.5406C418.227 48.5572 418.225 48.5747 418.227 48.592C418.229 48.6093 418.235 48.626 418.243 48.641C418.255 48.6586 418.27 48.6732 418.287 48.6838C418.305 48.6943 418.326 48.7005 418.346 48.7016H418.359C419.119 48.6261 419.87 48.4859 420.606 48.2826C422.648 47.7617 425.991 46.5958 430.305 43.9881C434.108 41.8245 435.789 39.0302 436.53 37.0665C437.011 35.8665 437.25 34.5832 437.233 33.2906C437.483 30.2983 437.759 29.6477 438.025 29.0184L438.073 28.908C438.75 27.6675 439.834 26.6978 441.142 26.1615L443.903 25.5876H443.907L450.555 24.2025C450.587 24.1959 450.614 24.1781 450.633 24.1524C450.652 24.1268 450.661 24.095 450.658 24.0633C450.653 24.0323 450.638 24.0039 450.615 23.9828C450.592 23.9617 450.562 23.9493 450.531 23.9478Z"
            fill="#010000" />
          <path d="M462.526 50.1999H468.118L466.296 44.3281H460.761L462.526 50.1999Z" fill="black" />
          <path d="M447.148 50.1999H452.535L454.165 44.3281H448.945L447.148 50.1999Z" fill="black" />
          <path
            d="M456.285 35.5402C456.66 34.2115 457.001 32.4726 457.342 31.1075H457.41C457.751 32.4726 458.16 34.1769 458.57 35.5402L459.436 38.4908H464.485L460.99 27.2207H454.172L450.728 38.4908H455.46L456.285 35.5402Z"
            fill="white" />
          <path d="M476.401 27.2207H471.184V50.2007H485.539V45.8362H476.4L476.401 27.2207Z" fill="black" />
          <path
            d="M507.018 27.2207H500.642L495.426 34.8583C494.914 35.6766 494.368 36.4953 493.857 37.3813H493.754V27.2207H488.606V50.2007H493.754V42.7L495.732 40.2788L501.359 50.2007H507.426L499.414 37.0058L507.018 27.2207Z"
            fill="white" />
          <path d="M522.599 21.7988H517.143L514.28 25.9919H518.406L522.599 21.7988Z" fill="black" />
          <path d="M514.757 31.4825H523.723V27.2207H509.54V36.0838H514.757V31.4825Z" fill="black" />
          <path d="M509.54 50.1995H524.201V45.9378H514.757V40.9609H509.54V50.1995Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="112.201" height="48" fill="white" transform="translate(412 12)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class='title'>
      <span>{{ "PDF.Preorder" | translate }} <b>{{ preorderId }}</b></span>
      <span>{{ "PDF.CreationDate" | translate }} <b>{{currentDate | date:'dd-MM-yyyy'}}</b></span>
    </div>
    <div class='jersey display-image border-top-image' *ngIf="this.kitJson.jersey">
      <span class='images'>
        <div class="jersey-container">
          <div class="jersey-preview-holder">
            <img class="jersey-preview" src="https://strapi.alkesoccer.com{{  jerseyImage?.Image?.url }}" alt="" />
            <div
              [ngClass]="jerseyImage?.maillot_modele?.Colibri_type === 'Centre' ? 'front-input center-shirt' : 'front-input bottom-shirt'">
              <img class="input-img" *ngIf="logoImage?.frontImage" [src]="logoImage?.frontImage" />
            </div>
            <div class="heart-input">
              <img *ngIf="logoImage?.heartImage" [src]="logoImage?.heartImage" />
            </div>
            <div class="left-input">
              <div class="logo-container">
                <img *ngIf="logoImage?.leftImage" [src]="logoImage?.leftImage" />
              </div>
            </div>
            <div class="right-input">
              <div class="logo-container">
                <img *ngIf="logoImage?.rightImage" [src]="logoImage?.rightImage" />
              </div>
            </div>
          </div>
        </div>
        <div class="jersey-container">
          <div class="jersey-preview-holder">
            <img class="jersey-preview" src="https://strapi.alkesoccer.com{{ jerseyImage?.image_dos?.url }}" alt="" />
            <div class="front-input back-shirt">
              <img class="input-img" *ngIf="logoImage?.backImage" [src]="logoImage?.backImage" />
            </div>
          </div>
        </div>
      </span>
      <span class='details'>
        <span class='header'><b>{{ "PDF.JerseyQuantity" | translate }}</b> {{kitService.getTotalJersey()}} items</span>
        <span class='content'>{{ "PDF.Modele" | translate }}: {{kitJson['jersey']['maillot_modele']['Col_type']}},
          {{kitJson['jersey']['maillot_modele']['Colibri_type']}} <br>
          {{ "PDF.Color" | translate }}: {{shirtColor | translate}} <br>
          {{ "PDF.ColibriColor" | translate }}: {{kitJson['jersey']['couleur_colibri'] | translate}} <br>
          {{ "PDF.Logo" | translate }}: {{uploadedImages | translate}}<br>
          {{ "PDF.nameColor" | translate }}: {{kitJson['colorName'] | translate}}<br>
          {{ "PDF.FlocageName" | translate }}: {{noName | translate}}<br>
          {{ "PDF.FlocageNumber" | translate }}: {{noNumber | translate}}</span>
      </span>
    </div>
    <div [ngClass]="!this.kitJson.shirt ? 'border-top-image short display-image': 'short display-image'"
      *ngIf="this.kitJson.short">
      <span class='images'>
        <div class="shorts-container">
          <div class="short-preview-holder">
            <img class="shorts-preview" src="https://strapi.alkesoccer.com{{ shortImage?.image?.url }}" alt="" />
            <div class="short-input"
              [ngClass]="kitJson?.short?.short_modele?.id === 2 ? 'mi-long' : kitJson?.short?.short_modele?.id === 3 ? 'sous-short' : ''">
              <img *ngIf="logoImage?.shortImage" [src]="logoImage?.shortImage" />
            </div>
          </div>
        </div>
        <div class="shorts-container">
          <div class="short-preview-holder">
            <img class="shorts-preview" src="https://strapi.alkesoccer.com{{ shortImage?.image_dos?.url }}" alt="" />
          </div>
        </div>
      </span>
      <span class='details'>
        <span class='header'><b>{{ "PDF.ShortQuantity" | translate }}</b> {{kitService.getTotalShort()}} items</span>
        <p class='content text-content'>{{ "PDF.ShortModele" | translate }} : {{kitJson['short']['short_modele']['nom']
          | translate}}
        </p>
        <p class='content text-content'>{{ "PDF.ShortColor" | translate }} : {{shortColor | translate}}
        </p>
      </span>
    </div>
    <div
      [ngClass]="!this.kitJson.shirt && !this.kitJson.short ? 'border-top-image sock display-image': 'sock display-image'"
      class='' *ngIf="this.kitJson.socks">
      <span class='images'>
        <img src="https://strapi.alkesoccer.com{{ socksImage?.image?.url }}" />
      </span>
      <span class='details'>
        <span class='header'><b>{{ "PDF.SocksQuantity" | translate }}</b> {{kitService.getTotalSocks()}} items</span>
        <span class='content'>{{ "PDF.SocksColor" | translate }} : {{kitJson['socks']['couleur'] | translate}}
        </span>
      </span>
    </div>
    <div class='size'>
      <img src="assets/images/size.svg" alt="" *ngIf="translationService.getLanguage() == 'fr'" />
      <img src="assets/images/size_en.svg" alt="" *ngIf="translationService.getLanguage() == 'en'"/>
      <img src="assets/images/socks-size.svg" alt="" *ngIf="translationService.getLanguage() == 'fr'"/>
      <img src="assets/images/socks-size_en.svg" alt="" *ngIf="translationService.getLanguage() == 'en'"/>

    </div>
    <div class='contact'>
      <span class="contact__title">{{ "PDF.Text1" | translate }}</span>
      <span class="contact__content">{{ "PDF.Text2" | translate }}</span>
      <span class="contact__content">{{ "PDF.Text3" | translate }}</span>
    </div>
    <div class='footer'>
      <span>Team Alke</span>
    </div>


  </section>
</div>

<section class="contact-info">
  <div class="ordered-header">
    <div class="green-border" (click)='back()'>
      <i class="arrow left"></i>

      <span class="back">{{ "Back" | translate }}</span>
    </div>

    <div class="container-title">
      <p class="contact-title">{{ "Contact.Info" | translate }}</p>
    </div>
    <div class="green-border-invisible">
      <i class="arrow left"></i>
      <span class="back">{{ "Back" | translate }}</span>
    </div>
  </div>

  <div class="main-container">
    <p>
      {{ "Choosing.Color" | translate }} <br />
      {{ "Choosing.Color.Two" | translate }}
    </p>
    <favie-local-spinner [componentId]="SUBMIT_SPINNER_ID">
      <form [formGroup]="angForm" (ngSubmit)="submit()" novalidate>
        <input type="text" placeholder="Nom *" formControlName="name" />
        <div *ngIf="
          angForm.controls['name'].invalid &&
          (angForm.controls['name'].dirty || angForm.controls['name'].touched)
        " class="alert">
          <div *ngIf="angForm.controls['name'].errors.required">
            {{ "Mandatory" | translate }}
          </div>
        </div>
        <input type="email" placeholder="Email *" formControlName="email" />
        <div *ngIf="
          angForm.controls['email'].invalid && angForm.controls['email'].touched" class="alert">
          <div *ngIf="angForm.controls['email'].errors.required">
            {{ "Mandatory" | translate }}
          </div>
          <div *ngIf="angForm.controls['email'].errors && !angForm.controls['email'].errors.required">
            {{ "InvalidFormat" | translate }}
          </div>
        </div>
        <input type="number" placeholder="Telephone *" formControlName="number" />
        <div *ngIf="
          angForm.controls['number'].invalid &&
          (angForm.controls['number'].dirty ||
            angForm.controls['number'].touched)
        " class="alert">
          <div *ngIf="angForm.controls['number'].errors.required">
            {{ "Mandatory" | translate }}
          </div>
        </div>
        <div class="checkbox-container">
          <label class="b-contain">
            <input type="checkbox" id="terms" name="terms" formControlName="terms" />
            <div class="b-input"></div>
            <a target="_blank" href="https://alkesoccer.com/fr/page/conditions-generales-de-vente">{{ "Terms" | translate }}</a>
          </label>
          <div *ngIf="
            angForm.controls['terms'].invalid &&
            (angForm.controls['terms'].dirty ||
              angForm.controls['terms'].touched)
          " class="alert">
            <div *ngIf="angForm.controls['number'].errors.required">
              {{ "Mandatory.Terms" | translate }}
            </div>
          </div>
        </div>
        <button type="submit" class="next-btn" [disabled]="angForm.pristine || angForm.invalid">
          {{ "Send.Info" | translate }}
        </button>
      </form>
    </favie-local-spinner>
  </div>
</section>